import classNames from 'classnames';

import AtSignIcon from '../../assets/builder/advantages/atsign.svg?react';
import ChartIcon from '../../assets/builder/advantages/chart.svg?react';
import ChatIcon from '../../assets/builder/advantages/chat.svg?react';
import CheckIcon from '../../assets/builder/advantages/check.svg?react';
import ClickIcon from '../../assets/builder/advantages/click.svg?react';
import CloudIcon from '../../assets/builder/advantages/cloud.svg?react';
import DownloadIcon from '../../assets/builder/advantages/download.svg?react';
import FileIcon from '../../assets/builder/advantages/file.svg?react';
import HeartIcon from '../../assets/builder/advantages/heart.svg?react';
import PeopleIcon from '../../assets/builder/advantages/people.svg?react';
import PlayIcon from '../../assets/builder/advantages/play.svg?react';
import VerifiedIcon from '../../assets/builder/advantages/verified.svg?react';
import WebIcon from '../../assets/builder/advantages/web.svg?react';

import { CheckoutComponentAdvantageAttibutesType } from '../../types/builder';

const CheckoutBuilderAdvantageSizes = {
  original: 'w-full',
  small: 'w-1/2',
  medium: 'w-2/3',
  large: 'w-3/4'
};

const icons = {
  atsign: AtSignIcon,
  chart: ChartIcon,
  chat: ChatIcon,
  check: CheckIcon,
  click: ClickIcon,
  cloud: CloudIcon,
  download: DownloadIcon,
  file: FileIcon,
  heart: HeartIcon,
  people: PeopleIcon,
  play: PlayIcon,
  verified: VerifiedIcon,
  web: WebIcon
};

const CheckoutComponentAdvantage: React.FC<CheckoutComponentAdvantageAttibutesType> = ({
  title,
  subtitle,
  icon,
  darkMode,
  primaryColor,
  size,
  titleTextColor,
  vertical
}) => {
  const Icon = icons[icon] || null;
  return (
    <div className="w-full flex justify-center">
      <div
        style={{
          backgroundColor: darkMode ? '#1A202C' : '#FFFFFF',
          borderColor: primaryColor,
          borderStyle: 'solid',
          borderWidth: '2px'
        }}
        className={classNames(
          CheckoutBuilderAdvantageSizes[size],
          'flex items-center p-5 gap-3 rounded-lg',
          {
            'flex-col items-center': vertical,
            'flex-row': !vertical
          }
        )}
      >
        {Icon && <Icon className="w-12 h-12" fill={primaryColor} />}
        <div
          className={classNames('flex flex-col gap-2 justify-center', {
            'items-start': !vertical,
            'items-center': vertical
          })}
        >
          <h3
            className="text-xl font-bold"
            style={{
              color: titleTextColor
            }}
          >
            {title}
          </h3>
          <p
            className="text-base"
            style={{
              color: primaryColor
            }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutComponentAdvantage;
